import { useAtomValue, useSetAtom } from 'jotai';

import type { CreditCardBrandInput } from '../CreditCard/creditcardTypes';

import {
  allSurchargesAtom,
  selectedCardBrandAtom,
  surchargeAtom,
} from './SurchargeStore';
import { getSurchargeByBrand } from './getSurcharge';

const useBrandSurcharge = () => {
  const allSurcharges = useAtomValue(allSurchargesAtom);
  const setSurcharge = useSetAtom(surchargeAtom);
  const setSelectedCardBrand = useSetAtom(selectedCardBrandAtom);

  const pickBrand = (brand: CreditCardBrandInput) => {
    setSelectedCardBrand(brand);
    setSurcharge(getSurchargeByBrand(allSurcharges, brand));
  };

  return {
    pickBrand,
  };
};

export default useBrandSurcharge;
